import {
  AlternativeTransportItineraryStop,
  VehicleStatus,
} from "shared/types/alternativeTransport";

export const timeFromKeys = (
  stop: AlternativeTransportItineraryStop | null,
  keys: Array<TimeKeys>,
): ReturnTypeTimeKeys => {
  if (stop === null) return null;

  return keys.map((key) => stop[key]).find((time) => time !== null) ?? null;
};

export const isStopCancelled = (
  stop: AlternativeTransportItineraryStop,
  vehicleStatus: VehicleStatus,
) =>
  stop.isDepartureCancelled ||
  stop.isArrivalCancelled ||
  vehicleStatus === "CANCELLED";

type TimeKeys =
  | "actualArrivalTime"
  | "actualDepartureTime"
  | "scheduledArrivalTime"
  | "scheduledDepartureTime"
  | "estimatedArrivalTime"
  | "estimatedDepartureTime";
type ReturnTypeTimeKeys = AlternativeTransportItineraryStop[keyof Pick<
  AlternativeTransportItineraryStop,
  TimeKeys
>];
